import React, { useRef, useState } from 'react';

interface UseMenuDialogResult {
  dialogType: string | null;
  triggerRef: React.RefObject<HTMLButtonElement | null>;
  openDialog: (type: string) => void;
  closeDialog: () => void;
  dialogProps: {
    open: boolean;
    onOpenChange: (open: boolean) => void;
  };
  dropdownProps: {
    open: boolean;
    onOpenChange: (open: boolean) => void;
  };
}

export function useMenuDialog(): UseMenuDialogResult {
  const [dialogType, setDialogType] = useState<string | null>(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const triggerRef = useRef<HTMLButtonElement>(null);

  const closeDialog = () => {
    setDialogType(null);
    setIsDialogOpen(false);
    setTimeout(() => {
      triggerRef.current?.focus();
    }, 1);
  };

  const openDialog = (type: string) => {
    setDialogType(type);
    setIsDialogOpen(true);
    setIsMenuOpen(false);
  };

  return {
    dialogType,
    triggerRef,
    openDialog,
    closeDialog,
    dialogProps: {
      open: isDialogOpen,
      onOpenChange: (open: boolean) => !open && closeDialog(),
    },
    dropdownProps: {
      open: isMenuOpen,
      onOpenChange: setIsMenuOpen,
    },
  };
}
